import React from "react";
import "./Footer.css";


const Footer = () => {
  return (
    <footer className="footContainer">
      <span>ET'S SPACE</span>
      <span>Made with care by Arghya</span>
    </footer>
  )
}

export default Footer